import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: modal;

  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  background: ${theme.colors.white};

  ${theme.media.giga} {
    flex-direction: row;
    min-height: 450px;
  }
`

const contentScrollStyles = ({ theme }) => css`
  label: modal__content;

  width: 100%;
  max-height: 60vh;
  min-height: 100%;

  overflow-y: auto;

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.n300};

    border-radius: 20px;
    border: 8px solid ${theme.colors.white};
  }

  ${theme.media.giga} {
    width: calc(100% - 180px);
    max-height: 450px;

    background: ${theme.colors.n100};

    &::-webkit-scrollbar {
      width: 20px;
    }

    &::-webkit-scrollbar-thumb {
      border: 8px solid ${theme.colors.n100};
    }
  }
`

const contentStyles = ({ theme }) => css`
  label: modal__content;

  padding: ${theme.spacings.giga} ${theme.spacings.tera};
`

const innerStyles = ({ theme }) => css`
  label: modal__inner;

  display: flex;
  flex-direction: column-reverse;

  width: 100%;

  ${theme.media.giga} {
    flex-direction: row;

    min-height: 450px;
  }
`

const asideStyles = ({ theme }) => css`
  label: modal__aside;

  display: flex;

  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  width: 100%;
  min-height: 100%;

  background: ${theme.colors.white};

  ${theme.media.giga} {
    width: 180px;
  }
`

export const Content = styled('div')(contentStyles)
export const ContentScroll = styled('div')(contentScrollStyles)
export const Inner = styled('div')(innerStyles)
export const Aside = styled('div')(asideStyles)

const wrapperActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    label: modal__wrapper--active;

    ${Aside} {
      background-image: linear-gradient(
        150deg,
        ${theme.colors.f700} 5%,
        ${theme.colors.v500} 100%
      );
    }
  `

export const Wrapper = styled('div')(wrapperStyles, wrapperActiveStyles)
